import React from 'react';
import PropTypes from 'prop-types';
import style from './Tag.module.scss';

const Tag = (props) => {

  let {
    name,
  } = props;

  return (
    <div className="badge badge-default">{name}</div>
  )

};

Tag.propTypes = {
  name: PropTypes.string,
};

export default Tag;
